import { Loader2 } from "lucide-react";
import { PageHeader } from "./page-header";
import { EmptyState } from "./empty-state";

interface DetailPageProps {
  isLoading: boolean;
  isError?: boolean;
  isNotFound?: boolean;
  title: string;
  subtitle?: string;
  breadcrumbs: { label: string; href?: string }[];
  actions?: React.ReactNode;
  errorMessage?: { title: string; description: string };
  notFoundMessage?: { title: string; description: string };
  children: React.ReactNode;
}

const defaultErrorMessage = {
  title: "Failed to load",
  description: "Something went wrong. Please try again.",
};

const defaultNotFoundMessage = {
  title: "Not found",
  description: "This item may have been deleted.",
};

export function DetailPage({
  isLoading,
  isError,
  isNotFound,
  title,
  subtitle,
  breadcrumbs,
  actions,
  errorMessage = defaultErrorMessage,
  notFoundMessage = defaultNotFoundMessage,
  children,
}: DetailPageProps) {
  if (isLoading) {
    return (
      <div
        className="flex items-center justify-center py-16"
        role="status"
        aria-label="Loading"
      >
        <Loader2 className="h-8 w-8 animate-spin text-[color:var(--color-text-lo)]" />
      </div>
    );
  }

  if (isError || isNotFound) {
    const message = isError ? errorMessage : notFoundMessage;
    return (
      <>
        <PageHeader breadcrumbs={breadcrumbs} title={title} />
        <EmptyState title={message.title} description={message.description} />
      </>
    );
  }

  return (
    <>
      <PageHeader
        breadcrumbs={breadcrumbs}
        title={title}
        subtitle={subtitle}
        actions={actions}
      />
      {children}
    </>
  );
}
